import React, { useCallback, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { EditorView } from '../BlockNote/EditorView';

interface MarkdownNoteSectionDisplayBoxProps {
  text: string;
  isNA?: boolean;
}

export const MarkdownNoteSectionDisplayBox = ({
  text,
  isNA = false,
}: MarkdownNoteSectionDisplayBoxProps) => {
  // Track document version for analytics (increments when text prop changes)
  const docVersionRef = useRef<number>(0);
  const lastTextRef = useRef<string>(text);
  useEffect(() => {
    if (lastTextRef.current !== text) {
      docVersionRef.current += 1;
      lastTextRef.current = text;
    }
  }, [text]);

  // Analytics configuration
  const analyticsDocId = 'display:markdown-note-section';
  const getDocVersion = useCallback(() => docVersionRef.current.toString(), []);

  return (
    <Box
      sx={{
        // Match styling from MarkdownNoteSection container
        pt: 4,
        border: 1,
        borderRadius: '0.75rem',
        color: isNA ? 'textColors.disabled' : 'textColors.darkText',
        borderColor: isNA
          ? 'borderColors.lightprimary' // Assuming theme structure
          : 'borderColors.primary',
        bgcolor: isNA ? 'backgroundColors.secondary' : 'backgroundColors.primary',
        position: 'relative',
        overflow: 'hidden',
        opacity: isNA ? 0.7 : 1,
      }}
    >
      <EditorView
        markdown={text}
        editable={false} // Read-only
        styleId="markdown-note-section-display-box"
        analytics={{
          enabled: true,
          docId: analyticsDocId,
          getDocVersion,
        }}
      />
    </Box>
  );
};

export default MarkdownNoteSectionDisplayBox;
